import axios from "../axios";
import bizConstant from "../constants/biz-constant";

const request = {
    getMovieList(data = {}) {
        let url = bizConstant.REQ_MOVIE_CITY_LIST;
        return axios.request({
            url,
            data,
        });
    },
    getBannerList(data = {}) {
        let url = bizConstant.REQ_BANNER_LIST;
        return axios.request({
            url,
            data,
        });
    },
    getMovieDetail(data = {}) {
        let url = bizConstant.REQ_MOVIE_DETAIL;
        return axios.request({
            url,
            data,
        })
    },
    getMovieActorImage(data = {}) {
        let url = bizConstant.REQ_MOVIE_ACTOR_IMAGE_GET;
        return axios.request({
            url,
            data
        })
    },
    getHotMovieList(data = {}) {
        let url = bizConstant.REQ_MOVIE_LIST_HOT;
        return axios.request({
            url,
            data,
        });
    },
    getFutureMovieList(data = {}) {
        let url = bizConstant.REQ_MOVIE_LIST_FUTURE;
        return axios.request({
            url,
            data,
        });
    },
    getCinemaList(data = {}) {
        let url = bizConstant.REQ_MOVIE_CINEMA_LIST;
        return axios.request({
            url,
            data
        })
    },
    getCinemaDetail(data = {}) {
        let url = bizConstant.REQ_MOVIE_CINEMA_DETAIL;
        return axios.request({
            url,
            data
        })
    },
    getMovieCinemaDateList(data = {}) {
        let url = bizConstant.REQ_MOVIE_CINEMA_DATE_LIST;
        return axios.request({
            url,
            data
        })
    },
    getMovieSessionList(data = {}) {
        let url = bizConstant.REQ_MOVIE_SESSION_LIST;
        return axios.request({
            url,
            data
        })
    },
    getMovieCinemaSeat(data = {}) {
        let url = bizConstant.REQ_MOVIE_CINEMA_SEAT;
        return axios.request({
            url,
            data
        })
    },
    getMovieCinemaActivitiesSeat(data = {}) {
        let url = bizConstant.REQ_MOVIE_CINEMA_ACTIVITIES_SEAT;
        return axios.request({
            url,
            data
        })
    },
    validateSelectedSeatList(data = {}) {
        let url = bizConstant.REQ_MOVIE_CINEMA_SEAT_VALIDATE;
        return axios.request({
            url,
            data
        })
    },
    createOrder(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_CREATE;
        return axios.request({
            url,
            data
        })
    },
    getOrder(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_GET;
        return axios.request({
            url,
            data
        })
    },
    getOrderRemaining(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_REMAINING;
        return axios.request({
            url,
            data
        });
    },
    getUnPaidOrder(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_UNPAID_GET;
        return axios.request({
            url,
            data
        })
    },
    getMemberOrderCouponList(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_COUPON_LIST;
        return axios.request({
            url,
            data
        })
    },
    modifyCouponByOrder(data = {}) {
        let url = bizConstant.REQ_MEMBER_COUPON_ORDER_MODIFY;
        return axios.request({
            url,
            data
        })
    },
    modifyUseVip(data = {}) {
        let url = bizConstant.REQ_MEMBER_VIP_ORDER_MODIFY;
        return axios.request({
            url,
            data
        })
    },
    getMemberCouponList(data = {}) {
        let url = bizConstant.REQ_MEMBER_COUPON_LIST;
        return axios.request({
            url,
            data
        });
    },
    getMemberVipList(data = {}) {
        let url = bizConstant.REQ_MEMBER_COUPON_VIP_LIST;
        return axios.request({
            url,
            data
        })
    },
    getMemberOrderList(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_LIST;
        return axios.request({
            url,
            data
        })
    },
    cancelMemberOrder(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_CANCEL;
        return axios.request({
            url,
            data,
        })
    },
    deleteMemberOrder(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_DELETE;
        return axios.request({
            url,
            data
        })
    },
    getCouponInfo(data = {}) {
        let url = bizConstant.REQ_MEMBER_COUPON_GET;
        return axios.request({
            url,
            data
        })

    },
    bindCoupon(data = {}) {
        let url = bizConstant.REQ_MEMBER_COUPON_ADD;
        return axios.request({
            url,
            data
        })
    },
    bindVip(data = {}) {
        let url = bizConstant.REQ_MEMBER_VIP_ADD;
        return axios.request({
            url,
            data
        });
    },
    getOrderDetail(data = {}) {
        let url = bizConstant.REQ_MEMBER_ORDER_DETAIL_GET;
        return axios.request({
            url,
            data
        })
    }
};

export default request;